import React, { Component } from "react";
import { Parallax } from "react-parallax";
import PropTypes from "prop-types";
import jump from "jump.js";
import RouteButton from "../RouteButton/RouteButton";
import "./Header.css";

var Scroll = require("react-scroll");

var scrollSpy = Scroll.scrollSpy;

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scrollID: "",
      scrollButtonDisplay: "inline-flex"
    };
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentWillMount() {
    this.setScrollID();
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
    scrollSpy.update();
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  setScrollID() {
    switch (this.props.page) {
      case "work":
        this.setState({ scrollID: "#work" });
        break;
      case "services":
        this.setState({ scrollID: "#services" });
        break;
      case "career":
        this.setState({ scrollID: "#career" });
        break;
      case "contact":
        this.setState({ scrollID: "#contact" });
        break;
      case "blog":
        this.setState({ scrollID: "#blog" });
        break;
      default:
        this.setState({ scrollID: "#do" });
    }
  }

  isMobile() {
    return window.innerWidth <= 768;
  }

  handleScroll() {
    window.scrollY > 0
      ? this.setState({
          scrollButtonDisplay: "none"
        })
      : this.setState({
          scrollButtonDisplay: "inline-flex"
        });
  }

  render() {
    return (
      <div className="header">
        <Parallax
          bgImage={this.props.bgImage}
          strength={this.isMobile() ? 0 : this.props.strength}
        >
          <header id="page-top" className="container-fluid mainHeader">
            <div className="intro-text row text-center">
            
              <div
                className={
                  this.props.page === "startPage" ? (
                    "col-12 text-center mx-auto"
                  ) : (
                    "col-12 col-md-5 text-center mx-auto"
                  )
                }
              >
                <h1
                  className={
                    this.props.page === "startPage" ? (
                      "introHeadingMargin"
                    ) : (
                      "intro-heading"
                    )
                  }
                >
                  {this.props.big_header}
                </h1>
                <div className="col-12">
                <h3 className="intro-lead-in"> {this.props.small_header} </h3>
              </div>
              </div>
              <div className="col-12">
                <div className="text-center">
                  {this.props.headerButtons.map(button => {
                    return (
                      <RouteButton
                        key={button.title}
                        linkTo={button.route}
                        class_names="btn-white"
                        buttonText={button.title}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="page-scroll col-12 text-center">
              <a
                role="presentation"
                onClick={() => {
                  jump(this.state.scrollID, {
                    duration: 1000,
                    offset: this.props.offset
                  });
                  this.setState({
                    scrollButtonDisplay: "none"
                  });
                }}
                style={{ display: this.state.scrollButtonDisplay }}
                className={
                  this.props.page === "startPage" ? (
                    "btn btn-circle btn-circle-startPage"
                  ) : (
                    "btn btn-circle"
                  )
                }
              >
                <i
                  role="presentation"
                  className="fa fa-angle-down fa-2x animated"
                />
              </a>
            </div>
          </header>
        </Parallax>
      </div>
    );
  }
}

Header.propTypes = {
  small_header: PropTypes.string,
  big_header: PropTypes.string,
  bgImage: PropTypes.string,
  strength: PropTypes.number,
  page: PropTypes.string,
  offset: PropTypes.number,
  headerButtons: PropTypes.array
};
Header.defaultProps = {
  small_header: null,
  big_header: null,
  bgImage: null,
  strength: null,
  page: null,
  offset: null,
  headerButtons: []
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx